import validate from "/app/node_modules/.pnpm/nuxt@3.21.0_@parcel+watcher@2.5.6_@types+node@18.19.130_@vue+compiler-sfc@3.5.27_cac@6.7.14_d_ijnilurh2h436m7epbriqrhvu4/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/app/middleware/redirects.global.ts";
import trailing_45slash_45global from "/app/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.21.0_@parcel+watcher@2.5.6_@types+node@18.19.130_@vue+compiler-sfc@3.5.27_cac@6.7.14_d_ijnilurh2h436m7epbriqrhvu4/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-desktop": () => import("/app/middleware/auth-desktop.ts"),
  "check-token-landing": () => import("/app/middleware/checkTokenLanding.ts"),
  "home-redirect": () => import("/app/middleware/home-redirect.ts"),
  "is-authenticated": () => import("/app/middleware/is-authenticated.ts"),
  "prevent-my-devices-not-enabled": () => import("/app/middleware/preventMyDevicesNotEnabled.ts")
}